import React, { useContext } from "react";
import styled from "styled-components";
import {
  TextField,
  FormGroup,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  FormControlLabel,
  Checkbox,
  FormHelperText,
} from "@material-ui/core";
//import { faIdCard } from '@fortawesome/pro-solid-svg-icons';

import { SubHeading } from "../ui/SubHeading";
import { UserContext } from "../../contexts/UserContext";
import CreditCardIcon from "@material-ui/icons/CreditCard";
//import { Row } from 'jspdf-autotable';
import { Grid } from "react-virtualized";

const CardSettings = () => {
  const { Site, handleSiteChange } = useContext(UserContext);
  const {
    custom1,
    custom1Enabled,
    custom1Length,
    custom2,
    custom2Enabled,
    custom2Length,
    custom3,
    custom3Enabled,
    custom3Length,
    printedID,
    siteType,
    photoRequired,
  } = Site;

  return (
    <div>
      <SubHeading>
        {" "}
        <CreditCardIcon style={Iconstyles} /> Card Settings
      </SubHeading>

      <FormControl>
        <InputLabel id="printedID">Printed ID</InputLabel>
        <Select
          name="printedID"
          value={printedID}
          onChange={handleSiteChange}
          label="Printed ID"
          labelId="printedID"
        >
          <MenuItem value="externalID">{`${
            siteType === 0 || siteType === 5 ? "Student" : "Staff"
          } ID`}</MenuItem>
          {siteType === 0 || siteType === 5 ? (
            <MenuItem value="curriculum">Curriculum Number</MenuItem>
          ) : (
            <></>
          )}
          {custom1Enabled && <MenuItem value="custom1">{custom1}</MenuItem>}
          {custom2Enabled && <MenuItem value="custom2">{custom2}</MenuItem>}
          {custom3Enabled && <MenuItem value="custom3">{custom3}</MenuItem>}
        </Select>
      </FormControl>
      <FormGroup>
        <CheckboxWithTextField>
          <FormControlLabel
            style={{ margin: "0", marginBottom: "-6px" }}
            control={
              <Checkbox
                name="custom1Enabled"
                onChange={handleSiteChange}
                checked={custom1Enabled}
              />
            }
            label=""
          />
          <TextField
            name="custom1"
            value={custom1}
            onChange={handleSiteChange}
            label="Custom Field 1"
            disabled={!custom1Enabled}
            style={{ marginRight: "10", width: "250px" }}
          />

          <TextField
            name="custom1Length"
            value={custom1Length}
            onChange={handleSiteChange}
            label="Size"
            disabled={!custom1Enabled}
            style={{ marginLeft: "10", width: "70px" }}
          ></TextField>
        </CheckboxWithTextField>

        <CheckboxWithTextField>
          <FormControlLabel
            style={{ margin: "0", marginBottom: "-6px" }}
            control={
              <Checkbox
                name="custom2Enabled"
                onChange={handleSiteChange}
                checked={custom2Enabled}
              />
            }
            label=""
          />
          <TextField
            name="custom2"
            value={custom2}
            onChange={handleSiteChange}
            label="Custom Field 2"
            disabled={!custom2Enabled}
            style={{ marginRight: "10", width: "250px" }}
          />

          <TextField
            name="custom2Length"
            value={custom2Length}
            onChange={handleSiteChange}
            label="Size"
            disabled={!custom2Enabled}
            style={{ marginLeft: "10", width: "70px" }}
          ></TextField>
        </CheckboxWithTextField>

        <CheckboxWithTextField>
          <FormControlLabel
            style={{ margin: "0", marginBottom: "-6px" }}
            control={
              <Checkbox
                name="custom3Enabled"
                onChange={handleSiteChange}
                checked={custom3Enabled}
              />
            }
            label=""
          />
          <TextField
            name="custom3"
            value={custom3}
            onChange={handleSiteChange}
            label="Custom Field 3"
            disabled={!custom3Enabled}
            style={{ marginRight: "10", width: "250px" }}
          />

          <TextField
            name="custom3Length"
            value={custom3Length}
            onChange={handleSiteChange}
            label="Size"
            disabled={!custom3Enabled}
            style={{ marginLeft: "10", width: "70px" }}
          ></TextField>
        </CheckboxWithTextField>
      </FormGroup>
      <Checkboxes>
        <FormControlLabel
          control={
            <Checkbox
              name="photoRequired"
              onChange={handleSiteChange}
              checked={photoRequired}
            />
          }
          label="Require Photo"
        />
        <FormHelperText>
          If enabled, you will not be able to order cards without a photo
        </FormHelperText>
      </Checkboxes>
    </div>
  );
};

const Iconstyles = {
  fontSize: "17px",
};

const CheckboxWithTextField = styled.div`
  display: flex;
  align-items: center;
`;

const Checkboxes = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.1rem;
`;

export default CardSettings;
